
<template>
  <HomepageWideLayout>
    <div class="hero-background">
      <b-container>
        <b-row>
          <b-col sm="12" lg="6">
            <div class="wrapper">
              <div class="hero-text-area">
                <h1 class="rw-sentence">
                  <span style="white-space: nowrap">Business cards</span>
                  <br />
                  <span style="white-space: nowrap">for teams made</span>
                  <br />
                  <div class="rw-words rw-words-1">
                    <span>simple</span>
                    <span>fast</span>
                    <span>easy</span>
                    <span>affordable</span>
                  </div>
                </h1>
                <h2>
                  Brandly is the fastest and easiest
                  <br />business card ordering solution
                  <br />for any size business.
                </h2>
                <div class="buttons">
                  <GetStartedButton />
                  <p>No credit card required. 1 minute setup.</p>
                </div>
              </div>
            </div>
          </b-col>
          <b-col sm="12" lg="6">
            <div class="hero-wrapper">
              <img class="hero-image" src="/static/images/homepage/hero/hero.png" />
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <BrandlyApp />
    <Testimonial />
    <Demo />
  </HomepageWideLayout>
</template>


<script>
export default {
  props: ["signedUp"]
};
</script>

<style lang="scss" scoped>
@import "~scss/colors";

/* Hero Text Section */

.hero-background {
  background: #fff; //layer background color
  overflow: hidden;
}

.wrapper {
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0;
}

.hero-text-area {
  font-family: Proxima Nova;
  margin: 1em;
}

.hero-text-area h1 {
  color: $black-0;
}

.hero-text-area h2 {
  font-size: 1.5rem;
  font-weight: 500 !important;
  font-stretch: normal;
  line-height: 1.3;
  letter-spacing: normal;
  color: $gray-0;
}

.hero-text-area p {
  font-size: 16px;
  margin-top: 1em;
  color: $gray-1; // "no credit card required" text
}

/* Hero Image Section */

.hero-image {
  padding-top: 50px;
  height: 600px;
}

h1 {
  font-size: 3.8rem;
  line-height: 1;
  margin-top: 0;
}

h2 {
  font-size: 50px;
  margin-bottom: 2em;
}

.herotext {
  animation-name: hero;
  animation-duration: 4s;
  animation-iteration-count: infinite;
}

#text2 {
  animation-delay: 2s;
}

@keyframes hero {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@media (max-width: 1140px) {
  .hero-image {
    height: 500px;
  }
}

@media (min-width: 992px) {
  .hero-wrapper {
    display: flex;
    justify-content: right;
    margin-left: -40px;
  }
}

@media (max-width: 992px) {
  .container {
    max-width: 720px;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
  }
  .hero-background {
    padding: 0;
  }
  .hero-text-area {
    padding-top: 2em;
    text-align: left;
  }
}

@media (max-width: 576px) {
  .hero-text-area {
    width: 100%;
  }
  h1 {
    font-size: 2.8rem;
  }
  h2 {
    font-size: 18px;
    line-height: 1.78;
  }
  .hero-wrapper {
    display: flex;
    justify-content: center;
  }

  .buttons {
    display: inline;
    text-align: left;
    align-items: center;
  }
  .buttons > * {
    margin-right: 0;
  }
}

// TESTIMONIAL LAYER

.testimonial {
  text-align: center;
  margin: 0 auto;
  padding: 1em 0em;
}

.testimonial-text-area {
  font-family: Proxima Nova;
  font-size: 22px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  max-width: 650px;
  padding: 1em;
  margin: 0 auto;
  text-align: center;
  color: $black-2; // testimonial copy color
}

@media (max-width: 767px) {
  .testimonial-text-area {
    text-align: center;
    font-size: 18px;
  }
}
.testimonial img {
  height: 40px;
}

// Small devices

@media (max-width: 415px) {
  h1 {
    font-size: 26pt;
  }
  h2 {
    font-size: 12pt !important;
  }
  .hero-wrapper {
    display: flex;
    justify-content: center;
  }
}

//hero animation

.rw-wrapper {
  position: relative;
}
.rw-sentence {
  margin: 0 0 1.5em 0;
  text-align: left;
}
.rw-sentence span {
  color: $black-1;
}
.rw-words {
  display: inline;
}
.rw-words-1 span {
  position: absolute;
  opacity: 0;
  overflow: hidden;
  color: $light-blue;

  animation: rotateWord 16s linear infinite 0s;
}
.rw-words-1 span:nth-child(2) {
  animation-delay: 4s;
  color: $medium-purple;
}
.rw-words-1 span:nth-child(3) {
  animation-delay: 8s;
  color: $yellow;
}
.rw-words-1 span:nth-child(4) {
  animation-delay: 12s;
  color: $dark-green;
}

@keyframes rotateWord {
  0% {
    opacity: 0;
  }
  2% {
    opacity: 0;
    transform: translateY(-30px);
  }
  5% {
    opacity: 1;
    transform: translateY(0px);
  }
  17% {
    opacity: 1;
    transform: translateY(0px);
  }
  20% {
    opacity: 0;
    transform: translateY(30px);
  }
  80% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/homepage/HomePage.vue